/* eslint-disable */
export default {
  downloadSuccess: 'Log downloaded.',
  downloadFail: 'Error log download failed. Please try again.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
